<template>
  <div
    :class="[
      col ? `col-${col}` : 'col',
      colSm,
      colMd,
      colLg,
      colXl,
      { 'self-start': selfStart },
      { 'self-end': selfEnd },
      { 'self-center': selfCenter },
      { 'self-baseline': selfBaseline },
      { 'self-stretch': selfStretch },
    ]"
  >
    <slot />
  </div>
</template>

<script>
import Vue from 'vue';

// https://quasar.dev/layout/grid/row
// https://quasar.dev/layout/grid/gutter

/**
 * This component using quasar Grid Column.
 * https://quasar.dev/layout/grid/row
 *
 * [Props]
 * col: 1 ~ 12
 * https://quasar.dev/layout/grid/row#Setting-one-column-width
 *
 * xs~xl: 1~12, auto (e.g. md: 6 => col-md-6)
 * https://quasar.dev/layout/grid/row#https://quasar.dev/layout/grid/row#Variable-width-content
 */

export default Vue.extend({
  name: 'CCol',
  props: {
    // Setting One Column Width
    col: { type: String, Number },

    // Variable Width Content
    xs: { type: [String, Number, Boolean] },
    sm: { type: [String, Number, Boolean] },
    md: { type: [String, Number, Boolean] },
    lg: { type: [String, Number, Boolean] },
    xl: { type: [String, Number, Boolean] },

    // Self Alignment
    selfStart: { type: Boolean },
    selfEnd: { type: Boolean },
    selfCenter: { type: Boolean },
    selfBaseline: { type: Boolean },
    selfStretch: { type: Boolean },
  },
  computed: {
    colXs() {
      if (this.xs === '') {
        return 'col-xs';
      }
      if (typeof this.xs === 'number' || typeof this.xs === 'string') {
        return `col-xs-${this.xs}`;
      }
      return '';
    },

    colSm() {
      if (this.sm === '') {
        return 'col-sm';
      }
      if (typeof this.sm === 'number' || typeof this.sm === 'string') {
        return `col-sm-${this.sm}`;
      }
      return '';
    },

    colMd() {
      if (typeof this.md === 'boolean') {
        if (this.md === '') {
          return 'col-md';
        }
      }
      if (typeof this.md === 'number' || typeof this.md === 'string') {
        return `col-md-${this.md}`;
      }
      return '';
    },

    colLg() {
      if (typeof this.lg === 'boolean') {
        if (this.lg === '') {
          return 'col-lg';
        }
      }
      if (typeof this.lg === 'number' || typeof this.lg === 'string') {
        return `col-lg-${this.lg}`;
      }
      return '';
    },

    colXl() {
      if (typeof this.xl === 'boolean') {
        if (this.xl === '') {
          return 'col-xl';
        }
      }
      if (typeof this.xl === 'number' || typeof this.xl === 'string') {
        return `col-xl-${this.xl}`;
      }
      return '';
    },
  },
});
</script>
